import * as utils from "//mesmerizeindia.com/cdn/shop/t/214/assets/utils.js?v=121444215945374234871764309502";

/* Custom theme Function */

/**
 * Toggle logic to show/hide size information text.
 * @param {string} action - The action to perform. Use 'remove' to show the text, or any other value to hide it.
 */
                
export function toggleSizeInfoText(action) {
  let infoTextSelectors = document.querySelectorAll("[data-size-info-text]");
  if(infoTextSelectors.length>0){
    let heightOffset = Number(infoTextSelectors[0].dataset.heightOffset);
    if (!infoTextSelectors || infoTextSelectors.length === 0) return;
    infoTextSelectors.forEach(infoTextSelector => {
      if (action === 'remove') {
        infoTextSelector.classList.remove("hide");
        const element = document.querySelector(".variant-picker__option-values");
        let offsetTop = element.offsetTop;
        let targetScroll = offsetTop - heightOffset;
        window.scrollTo({
          top: targetScroll,
          behavior: 'smooth',
          block: 'nearest', 
          inline: 'start'
        });
      } else {
        infoTextSelector.classList.add("hide");
      }
    });
  }
}

export class VariantMetaFieldFeatures {
  constructor(product, variantId) {
    this.product = product;
    this.variantId = variantId;
    this._abortController = new AbortController(); 
    //Feature Cards
    this.variantCardMappingSelector = null;
    this.variantIdCardMapping = null;
    this.variantIdCardMappingJSON = null;
    //Pre order
    this.variantPreorderMappingSelector = null;
    this.variantIdPreorderMapping = null;
    this.variantIdPreorderMappingJSON = null;
    document.addEventListener("variant:preorder", this.setVariantToPreorder.bind(this));
  }


  /**
   * Retrieves the variant card mapping from the DOM using a selector
   * @param {string} selector - The ID of the element that contains the card mapping data.
   */
  getVariantCardMapping(selector) {
    if (this.product) {
       this.variantCardMappingSelector = document.getElementById(selector);
       if (this.variantCardMappingSelector) {
        this.variantIdCardMapping = this.variantCardMappingSelector.dataset.cardMapping;
        this.variantIdCardMappingJSON = this.variantIdCardMapping === '' ? undefined : JSON.parse(this.variantIdCardMapping);
      }
    }
  }

  /**
   * Retrieves the feature cards for the selected variant based on its ID.
   * @param {number | string} id - The ID of the variant to fetch feature cards for.
   * @returns {Array} An array of feature cards that match the provided variant ID.
   */
  getSelectedVariantFeatureCards(id) {
    if (this.variantIdCardMappingJSON && Array.isArray(this.variantIdCardMappingJSON)) {
      const selectedVariantFeatureCards = this.variantIdCardMappingJSON.filter(card => card.variant_id === Number(id));
      return selectedVariantFeatureCards;
    } else {
      return [];
    }
  }

  /**
   * Generates and appends variant feature cards dynamically to the rootSelector.
   * @param {number} id - The variant ID to filter the feature cards by.
   */
  createVariantFeatureCards(id) {
    const selectedVariantCards = this.getSelectedVariantFeatureCards(id);
    const rootSelector = document.querySelectorAll(".product-info__variant-offer-list");

    rootSelector.forEach(root => {
      root.innerHTML = '';
    });

    // If rootSelector is empty or no cards are selected, exit the function early
    if (rootSelector.length === 0 || selectedVariantCards.length === 0) return;

    const rootSelectorDataAttr = rootSelector[0].dataset;
    const { cardBg, iconPosition, textAlignment, cardText } = rootSelectorDataAttr;

    const offerListContainer = document.createElement('div');
    offerListContainer.classList.add('product-info__offer-list');

    // Create individual offer cards and append them inside the offer list container
    selectedVariantCards[0].feature_cards.forEach(card => {
      const offerCard = document.createElement('div');
      const alignmentClass = textAlignment === "center" ? 'offer--center' : '';
      offerCard.classList.add('offer');
      if (alignmentClass) {
        offerCard.classList.add(alignmentClass);
      }

      const iconPositionClass = iconPosition === 'aligned' ? "text-with-icon" : "text-without-icon";

      offerCard.style.backgroundColor = cardBg;
      offerCard.style.color = cardText;
      offerCard.innerHTML = `
        <div class="${iconPositionClass}">
          ${card.icon_svg}
          <span class="bold text-sm">${card.heading}</span>
        </div>
        ${card.description ? `
          <div class="prose text-sm">
            ${card.description}
          </div>
        ` : ''}
      `;

      offerListContainer.appendChild(offerCard);
    });

    rootSelector[0].appendChild(offerListContainer);
  }


  /**
 * Retrieves the preorder mapping data from the DOM element specified by the selector.
 * It assigns the parsed JSON data to the class properties for further usage.
 * @param {string} selector - The ID of the DOM element containing the preorder mapping data.
 */
  getVariantPreorderMapping(selector) {
     if (this.product) {
       this.variantPreorderMappingSelector = document.getElementById(selector);
       if(this.variantPreorderMappingSelector){
       this.variantIdPreOrderMapping = this.variantPreorderMappingSelector.dataset.preorderMapping;
       this.variantIdPreOrderMappingJSON = JSON.parse(this.variantIdPreOrderMapping);
      }
     }
  }

  /**
 * Retrieves the selected preorder variant based on the provided variant ID.
 * It searches for the variant in the parsed JSON mapping.
 * @param {string|number} id - The variant ID to search for in the preorder mapping.
 * @returns {Array} - Returns an array containing the matched variant object, or an empty array if no match is found.
 */
  getSelectedPreorderVariant(id) {
  if (Array.isArray(this.variantIdPreOrderMappingJSON)) {
    return this.variantIdPreOrderMappingJSON.filter(map => map.variant_id === Number(id)) || [];
  }
  return [];
}
  
  /**
 * Handles the preorder process for a product variant by updating the visibility of the preorder container 
 * and modifying the "Add to Cart" buttons based on the variant's ship date.
 * @param {Event} event - The event triggered when the preorder process is initiated.
 */
  setVariantToPreorder(event) {
    const { variantId } = event.detail;
    const variant = this.getSelectedPreorderVariant(variantId)[0];
    let currentDate = new Date();
    const shipDateObj = variant ? new Date(variant['variant_preorder_shipdate']) : currentDate;
    currentDate.setHours(0, 0, 0, 0);
    const hasPreorder = shipDateObj > currentDate ? true : false;
    
    // Update preorder container visibility and message using innerHTML
    document.querySelectorAll(".product-variant__Ship-date").forEach(container => {
      container.style.display = hasPreorder ? "block" : "none";
      container.innerHTML = hasPreorder ? 
        `<p class="bold mb-10">Will ship by ${utils.formatDateToDDMMYYYY(shipDateObj)}</p>` : "";
    });
  
    // Update Add to Cart buttons
    const buttons = [
      ...document.querySelectorAll('.product-info button[type="submit"]'),
      ...document.querySelectorAll('.product-quick-add button[type="submit"]')
    ];
  
    buttons.forEach(button => {
      if (hasPreorder) {
        const buttonText = button.getAttribute("is") === "custom-button" ? button.firstElementChild : button;
        if (buttonText) buttonText.textContent = window.themeVariables.strings.preOrderButton; // Safely update text content
      }
    });
  }

}

// quantity-selector-pack.js
/**
 * Enhanced formatMoney function that handles currency conversion properly
 * @param {number} amount - Price amount in cents.
 * @returns {string} - Formatted currency string.
 */
function formatMoney(amount) {
  // Use the proper currency format from theme settings
  const currencyFormat = window.themeVariables?.settings?.currencyCodeEnabled 
    ? window.themeVariables.settings.moneyWithCurrencyFormat 
    : window.themeVariables?.settings?.moneyFormat;

  // First try to use the global theme formatMoney function
  if (typeof window.formatMoney === "function" && currencyFormat) {
    return window.formatMoney(amount, currencyFormat);
  }

  // Fallback to Shopify's formatMoney if available
  if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function" && currencyFormat) {
    return Shopify.formatMoney(amount, currencyFormat);
  }

  // Enhanced fallback for INR currency (no decimals)
  const currency = Shopify?.currency?.active || "INR";
  
  if (currency === "INR") {
    // For INR, format without decimals and with ₹ symbol
    const formattedAmount = Math.round(amount / 100).toLocaleString('en-IN');
    return `₹${formattedAmount}`;
  }

  // For other currencies, use browser's Intl API
  const formatter = new Intl.NumberFormat(navigator.language || "en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  return formatter.format(Math.round(amount / 100));
}

// Add CSS for smoother, slower transitions with slide effect
(function addTransitionStyles() {
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    /* Smooth transition for price changes */
    .sticky-price .discounted-price-list sale-price,
    .sticky-price .discounted-price-list compare-at-price {
      transition: opacity 0.7s ease-out, transform 0.7s ease-out;
      display: inline-block;
      transform-origin: top center;
    }
    
    .price-updating {
      opacity: 0;
      transform: translateY(-10px);
    }
    
    .price-entering {
      opacity: 0;
      transform: translateY(10px);
    }
  `;
  document.head.appendChild(styleElement);
})();

// Enhanced CSS for ultra-smooth transitions
(function addEnhancedTransitionStyles() {
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    /* Ultra-smooth price transitions */
    .sticky-price .discounted-price-list sale-price,
    .sticky-price .discounted-price-list compare-at-price,
    .quantity-selector-pack__button .combo-final,
    .quantity-selector-pack__button .combo-mrp span {
      transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      transform-origin: center;
    }
    
    .price-updating {
      opacity: 0.7;
      transform: scale(0.98);
    }
    
    .price-placeholder {
      opacity: 0.5;
      animation: pulse 1s infinite;
    }
    
    @keyframes pulse {
      0%, 100% { opacity: 0.5; }
      50% { opacity: 0.8; }
    }
  `;
  document.head.appendChild(styleElement);
})();

class QuantitySelectorPack extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this._onQuantityInputChanged = this.updateTotalPrice.bind(this);
    this._isUpdatingPrice = false;
  }

  connectedCallback() {
    this.classList.remove("hidden");
    this.style.display = "block";

    this.config = window.quantitySelectorConfig || {};
    this.formId = this.getAttribute("form_id") || this.config.formId;

    if (this.hasAttribute("variant")) {
      try {
        this.currentVariant = JSON.parse(this.getAttribute("variant"));
      } catch (error) {
        console.error("Error parsing variant attribute:", error);
      }
    } else if (window.defaultVariant) {
      this.currentVariant = window.defaultVariant;
    }

    // Set initial selected button
    const preselected = this.querySelector(".quantity-selector-pack__button.selected");
    if (preselected) {
      this.selectedOption = preselected.id;
    }

    // Add event listeners
    const form = document.getElementById(this.formId);
    if (form) {
      form.addEventListener("variant:change", this._onVariantChangedListener);
    }

    const quantityInput = document.getElementById(`${this.formId}-quantity`);
    if (quantityInput) {
      quantityInput.addEventListener("input", this._onQuantityInputChanged);
      quantityInput.addEventListener("change", this._onQuantityInputChanged);
    }

    // Initial price update
    requestAnimationFrame(() => {
      this.updateAllPricesWithThemeFormatting();
      this.updateStickyPricesDirectly();
    });
  }

  disconnectedCallback() {
    const form = document.getElementById(this.formId);
    if (form) {
      form.removeEventListener("variant:change", this._onVariantChangedListener);
    }
    const quantityInput = document.getElementById(`${this.formId}-quantity`);
    if (quantityInput) {
      quantityInput.removeEventListener("input", this._onQuantityInputChanged);
      quantityInput.removeEventListener("change", this._onQuantityInputChanged);
    }
  }

  _onVariantChanged(event) {
    console.log('🚀 Variant change detected');
    
    const { variant } = event.detail;
    const { available } = variant;
    
    if (!available) {
      this.style.display = "none";
      return;
    } else {
      this.style.display = "block";
    }

    // Store the currently selected button BEFORE any updates
    const currentlySelectedButton = this.getCurrentlySelectedButton();
    const selectedButtonId = currentlySelectedButton ? currentlySelectedButton.id : null;
    
    // Update variant immediately
    this.currentVariant = variant;
    window.defaultVariant = variant;

    // Update prices immediately
    requestAnimationFrame(() => {
      this.updateAllPricesWithThemeFormatting();
      
      // Restore selection
      if (selectedButtonId) {
        const buttonToReselect = this.querySelector(`#${selectedButtonId}`);
        if (buttonToReselect) {
          const allButtons = this.querySelectorAll(".quantity-selector-pack__button");
          allButtons.forEach(btn => btn.classList.remove("selected"));
          buttonToReselect.classList.add("selected");
          this.selectedOption = selectedButtonId;
        }
      }
      
      // Update sticky prices using the SAME approach as theme
      this.updateStickyPricesDirectly();
    });
    
    // Handle inventory
    const stock = this.config.stock
    
    this.clearHurryMessage();
    this.updateHurryMessage(stock);
  }

  updateAllPricesWithThemeFormatting() {
    if (!this.currentVariant || this._isUpdatingPrice) return;
    
    this._isUpdatingPrice = true;
    
    try {
      const variant = this.currentVariant;
      const config = this.config;
      
      console.log('🔢 Updating button prices:', {
        variantPrice: variant.price,
        comparePrice: variant.compare_at_price
      });
      
      // Update each button using theme's formatMoney
      this.updateButtonWithThemeFormatting('button1', variant, config);
      this.updateButtonWithThemeFormatting('button2', variant, config);
      this.updateButtonWithThemeFormatting('button3', variant, config);
      
    } catch (error) {
      console.error("❌ Error updating prices:", error);
    } finally {
      this._isUpdatingPrice = false;
    }
  }

  updateButtonWithThemeFormatting(buttonType, variant, config) {
    const buttonElement = document.querySelector(`#${buttonType.replace('button', 'button-')}`);
    if (!buttonElement) return;
    
    let quantity = 1;
    let discountPct = 0;
    
    if (buttonType === 'button1') {
      quantity = config.button1_quantity || 1;
      discountPct = config.button1_discount_off || 0;
    } else if (buttonType === 'button2') {
      quantity = config.button2Quantity || 2;
      discountPct = config.button2_discount_off || 15;
    } else if (buttonType === 'button3') {
      quantity = config.button3Quantity || 3;
      discountPct = config.button3_discount_off || 20;
    }
    
    // EXACT same calculation as CompactComboOffers
    const basePrice = variant.price * quantity;
    const adjustedPrice = Math.floor((basePrice * (1 - discountPct / 100)) / 100) * 100;
    const comparePrice = variant.compare_at_price ? variant.compare_at_price * quantity : 0;
    
    // CRITICAL: Use the GLOBAL theme formatMoney function (same as CompactComboOffers)
    const priceEl = buttonElement.querySelector(".combo-final");
    if (priceEl) {
      // Use the EXACT same formatMoney as theme
      priceEl.innerHTML = this.formatMoneyLikeTheme(adjustedPrice);
    }
    
    const mrpEl = buttonElement.querySelector(".combo-mrp span");
    const mrpDirectEl = buttonElement.querySelector(".combo-mrp");

    if (mrpEl) {
      if (discountPct > 0) {
        const mrpPrice = comparePrice > 0 ? comparePrice : basePrice;
        mrpEl.innerHTML = this.formatMoneyLikeTheme(mrpPrice);
        mrpEl.parentElement.style.display = "";
      } else {
        mrpEl.parentElement.style.display = "none";
      }
    }

    // Handle the direct .combo-mrp element for button1 when no discount
    if (mrpDirectEl && !mrpDirectEl.querySelector(".combo-mrp-full-price") && buttonType === 'button1') {
      if (discountPct === 0) {
        // Always show compare price value, even if it's 0
        if (comparePrice > 0) {
          mrpDirectEl.innerHTML = this.formatMoneyLikeTheme(comparePrice);
          mrpDirectEl.style.textDecoration = "line-through";
        } else {
          mrpDirectEl.innerHTML = "Full Price";
          mrpDirectEl.style.textDecoration = "none";
        }
        mrpDirectEl.style.display = "";
      } else {
        mrpDirectEl.style.display = "";
      }
    }
    
    const discEl = buttonElement.querySelector(".combo-discount");
    if (discEl) {
      if (discountPct > 0) {
        discEl.innerHTML = `${Math.round(discountPct)}% OFF`;
        discEl.style.display = "";
      } else {
        discEl.style.display = "none";
      }
    }
  }

  // CRITICAL: New method that uses the EXACT same approach as theme's SalePrice/CompareAtPrice
  updateStickyPricesDirectly() {
    if (!this.currentVariant) return;
    
    const stickyPriceContainers = document.querySelectorAll(".sticky-price .discounted-price-list");
    if (stickyPriceContainers.length === 0) return;
    
    // Get the selected button configuration
    const selectedButton = this.getCurrentlySelectedButton();
    let quantity = 1;
    let discountPct = 0;
    
    if (selectedButton) {
      const buttonId = selectedButton.id;
      if (buttonId === 'button-1') {
        quantity = this.config.button1_quantity || 1;
        discountPct = this.config.button1_discount_off || 0;
      } else if (buttonId === 'button-2') {
        quantity = this.config.button2Quantity || 2;
        discountPct = this.config.button2_discount_off || 15;
      } else if (buttonId === 'button-3') {
        quantity = this.config.button3Quantity || 3;
        discountPct = this.config.button3_discount_off || 20;
      }
    }
    
    // Calculate prices using EXACT same logic as quantity selector buttons
    const basePrice = this.currentVariant.price * quantity;
    const adjustedPrice = Math.floor((basePrice * (1 - discountPct / 100)) / 100) * 100;

    // Priority: compare_at > 0 → use it; else if discounted (discountPct > 0) → use base as struck; else 0
    const comparePrice = (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > 0)
      ? this.currentVariant.compare_at_price * quantity
      : (discountPct > 0 ? basePrice : 0);

    const hasDiscount = comparePrice > adjustedPrice;
    
    // Update using theme's formatMoney (EXACT same as SalePrice/CompareAtPrice)
    const saleElements = document.querySelectorAll(".sticky-price .discounted-price-list sale-price");
    const compareElements = document.querySelectorAll(".sticky-price .discounted-price-list compare-at-price");
    
    saleElements.forEach((element) => {
      // CRITICAL: Use the same approach as theme's SalePrice component
      const formattedPrice = this.formatMoneyLikeTheme(adjustedPrice);
      const fragment = document.createRange().createContextualFragment(formattedPrice);
      
      // Preserve sr-only span like theme does
      const srOnlySpan = element.querySelector('span.sr-only');
      if (srOnlySpan) {
        // Remove everything after sr-only span
        while (srOnlySpan.nextSibling) {
          srOnlySpan.nextSibling.remove();
        }
        element.appendChild(fragment);
      } else {
        element.innerHTML = '';
        element.appendChild(fragment);
      }
      
      // Apply discount styling like theme does
      //if (hasDiscount) {
        //element.classList.remove('text-lg');
      //} else {
       // element.classList.add('text-lg');
      //}
    });
    
    compareElements.forEach((element) => {
      if (comparePrice > 0) {
        const formattedComparePrice = this.formatMoneyLikeTheme(comparePrice);
        const fragment = document.createRange().createContextualFragment(formattedComparePrice);
        
        const srOnlySpan = element.querySelector('span.sr-only');
        if (srOnlySpan) {
          while (srOnlySpan.nextSibling) {
            srOnlySpan.nextSibling.remove();
          }
          element.appendChild(fragment);
        } else {
          element.innerHTML = '';
          element.appendChild(fragment);
        }
        
        element.hidden = false;
        element.style.display = "";
      } else {
        element.hidden = true;
        element.style.display = "none";
      }
    });
  }

  // Use the EXACT same formatMoney function as the theme (from theme.js line 81-132)
  formatMoneyLikeTheme(cents) {
    // CRITICAL: Always use the theme's global formatMoney function and currency format
    const currencyFormat = window.themeVariables?.settings?.currencyCodeEnabled 
      ? window.themeVariables.settings.moneyWithCurrencyFormat 
      : window.themeVariables?.settings?.moneyFormat;
    
    // First priority: Use global theme formatMoney if available
    if (typeof window.formatMoney === "function" && currencyFormat) {
      return window.formatMoney(cents, currencyFormat);
    }
    
    // Second priority: Use Shopify's formatMoney with current currency format
    if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function" && currencyFormat) {
      return Shopify.formatMoney(cents, currencyFormat);
    }
    
    // CRITICAL: For fallback, use the EXACT same logic as theme.js formatMoney function
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    
    // Use the current currency format from theme settings
    const formatString = currencyFormat || window.themeVariables?.settings?.moneyFormat || "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    
    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }
    
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split(".");
      let dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      let centsAmount = parts[1] ? decimal + parts[1] : "";

      // Remove .00 for whole numbers (same as theme)
      if (centsAmount === ".00") centsAmount = "";
      return dollarsAmount + centsAmount;
    }
    
    let value = "";
    const match = formatString.match(placeholderRegex);
    if (!match) return formatWithDelimiters(cents, 2);
    
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    
    return formatString.replace(placeholderRegex, value);
  }

  // Legacy method names for compatibility
  updateAllPricesInCurrentCurrency() {
    return this.updateAllPricesWithThemeFormatting();
  }

  updateTotalPrice() {
    return this.updateAllPricesWithThemeFormatting();
  }

  updateStickyPricesWithThemeFormatting() {
    return this.updateStickyPricesDirectly();
  }

  // Add this method to ensure currency consistency
  ensureCurrencyConsistency() {
    // Force refresh of currency format from theme variables
    const currencyFormat = window.themeVariables?.settings?.currencyCodeEnabled 
      ? window.themeVariables.settings.moneyWithCurrencyFormat 
      : window.themeVariables?.settings?.moneyFormat;
    
    return currencyFormat;
  }

  // Update the setQuantity method to ensure currency consistency
  setQuantity(quantity, buttonId) {
    
    this.selectedOption = buttonId;

    // Clear previously selected styles
    const buttons = this.querySelectorAll(".quantity-selector-pack__button");
    buttons.forEach((btn) => {
      btn.classList.remove("selected");
    });

    // Apply highlight to newly selected
    const selectedButton = this.querySelector(`#${buttonId}`);
    if (selectedButton) {
      selectedButton.classList.add("selected");
    }

    // Update the quantity input
    const quantityInput = document.getElementById(`${this.formId}-quantity`);
    if (quantityInput) {
      quantityInput.value = quantity;
    }

    // Update sticky prices display
    requestAnimationFrame(() => {
      this.updateStickyPricesDirectly();
    });
  }

  clearHurryMessage() {
    const existingMessage = this.querySelector(".hurry-message");
    if (existingMessage) {
        existingMessage.remove();
    }
  }

  updateHurryMessage(stock) {
    this.clearHurryMessage();

    const button1 = this.querySelector("#button-1");
    const button2 = this.querySelector("#button-2");
    const button3 = this.querySelector("#button-3");
    const continueSelling = this.config.continueSelling;

    // Get quantities from config
    const button2Quantity = this.config.button2Quantity || 2;
    const button3Quantity = this.config.button3Quantity || 3;

    if (continueSelling) {
        if (button1) button1.style.display = "";
        if (button2) button2.style.display = "";
        if (button3) button3.style.display = "";
        return;
    }

    if (stock <= 1) {
        // If stock is 1 or less, show hurry message and hide quantity selector
        const hurryMessage = document.createElement("p");
        hurryMessage.className = "hurry-message";
        hurryMessage.textContent = `Hurry, only ${stock} ${stock === 1 ? "item" : "items"} left in stock!`;
        hurryMessage.style.color = "#AF2A2A";
        this.appendChild(hurryMessage);

        // Hide all buttons when stock is 1 or less
        if (button1) button1.style.display = "none";
        if (button2) button2.style.display = "none";
        if (button3) button3.style.display = "none";
        
        // Hide the entire quantity selector
        this.style.display = "none";
    } else {
        // Show button1 always if stock > 1
        if (button1) button1.style.display = "";
        
        // Show button2 only if stock >= button2Quantity
        if (button2) {
            button2.style.display = stock >= button2Quantity ? "" : "none";
        }
        
        // Show button3 only if stock >= button3Quantity
        if (button3) {
            button3.style.display = stock >= button3Quantity ? "" : "none";
        }

        // If no buttons are visible except button1, select button1
        const visibleButtons = [button2, button3].filter(btn => 
            btn && btn.style.display !== "none"
        ).length;

        if (visibleButtons === 0) {
            // Only button1 is visible, make sure it's selected
            if (button1) {
                button1.classList.add("selected");
                this.setQuantity(1, "button-1");
            }
        }
    }
  }

  getCurrentlySelectedButton() {
    return this.querySelector(".quantity-selector-pack__button.selected") || 
           this.querySelector(`#${this.selectedOption}`);
  }
}

// Register custom element
if (!window.customElements.get("quantity-selector-pack")) {
  window.customElements.define("quantity-selector-pack", QuantitySelectorPack);
}

// Global setQuantity function
window.setQuantity = (quantity, buttonId) => {
  const qs = document.querySelector("quantity-selector-pack");
  if (qs) {
    qs.setQuantity(quantity, buttonId);
  }
};

// Modify the document variant:change handler for better default price handling
document.addEventListener("variant:change", (event) => {
  
  if (!event.detail.variant) return;
  window.defaultVariant = event.detail.variant;
  
  // Get sticky price elements
  const stickyPrices = document.querySelectorAll(".sticky-price .discounted-price-list sale-price");
  const compareEls = document.querySelectorAll(".sticky-price .discounted-price-list compare-at-price");
  
  if (stickyPrices.length === 0) return;
  
  // Calculate prices
  let salePrice, comparePrice, hasDiscount = false;
  const variant = event.detail.variant;
  const config = window.quantitySelectorConfig || {};
  
  // Find the quantity selector component
  const qs = document.querySelector("quantity-selector-pack");
  const quantitySelectorExists = qs && window.getComputedStyle(qs).display !== "none";
  
  if (quantitySelectorExists) {
    // Check if any button is selected and visible
    const selectedButton = qs.querySelector(".quantity-selector-pack__button.selected");
    const isButtonSelected = selectedButton && 
      selectedButton.style.display !== "none" && 
      window.getComputedStyle(selectedButton).display !== "none";
    
    if (isButtonSelected) {
      // Use the selected button's discount calculation
      const buttonType = selectedButton.id === "button-2" ? "button2" : 
                        (selectedButton.id === "button-3" ? "button3" : "button1");
                        
      const result = calculateDiscountedPriceForButton(variant, buttonType, config);
      salePrice = result.salePrice;
      comparePrice = result.comparePrice;
      hasDiscount = comparePrice > salePrice;
      
      // Set flags for the component
      qs._skipAnimation = true;
      qs._preUpdatedPrice = true;
    } else {
      // No button selected - use base variant price with button1 settings
      const button1Quantity = config.button1_quantity || 1;
      const button1Discount = config.button1_discount_off || 0;
      
      if (button1Discount > 0) {
        // Apply button1 discount
        const result = calculateDiscountedPriceForButton(variant, "button1", config);
        salePrice = result.salePrice;
        comparePrice = result.comparePrice;
        hasDiscount = comparePrice > salePrice;
      } else {
        // No discount, use simple variant price
        salePrice = variant.price * button1Quantity;
        comparePrice = variant.compare_at_price ? variant.compare_at_price * button1Quantity : 0;
        hasDiscount = comparePrice > salePrice;
      }
    }
  } else {
    // No quantity selector or hidden - use direct variant prices
    salePrice = variant.price;
    comparePrice = variant.compare_at_price || 0;
    hasDiscount = comparePrice > salePrice;
  }
  
  // Update the sticky prices
  stickyPrices.forEach(el => {
    // Format price with the theme's currency format
    const formattedPrice = formatMoney(salePrice);
    
    // Create a document fragment for the new content
    const fragment = document.createRange().createContextualFragment(formattedPrice);
    
    // Preserve sr-only span if it exists
    const srOnlySpan = el.querySelector('span.sr-only');
    if (srOnlySpan) {
      // Remove everything after sr-only span
      while (srOnlySpan.nextSibling) {
        srOnlySpan.nextSibling.remove();
      }
      el.appendChild(fragment);
    } else {
      el.innerHTML = formattedPrice;
    }
    
    // Clear any transition classes
    el.classList.remove('price-updating');
    el.classList.remove('price-entering');
    
    // Update styling based on discount
    //if (hasDiscount) {
      //el.classList.remove('text-lg');
    //} else {
      //el.classList.add('text-lg');
   // }
    
    // Ensure visibility
    el.style.opacity = "1";
    el.style.display = "";
  });
  
  // Handle compare price elements
  compareEls.forEach(el => {
    if (comparePrice > 0) {
      const formattedCompare = formatMoney(comparePrice);
      const fragment = document.createRange().createContextualFragment(formattedCompare);
      
      const srOnlySpan = el.querySelector('span.sr-only');
      if (srOnlySpan) {
        while (srOnlySpan.nextSibling) {
          srOnlySpan.nextSibling.remove();
        }
        el.appendChild(fragment);
      } else {
        el.innerHTML = formattedCompare;
      }
      
      el.style.opacity = "1";
      el.style.display = "";
      el.removeAttribute('hidden');
    } else {
      el.style.display = "none";
      el.setAttribute('hidden', '');
    }
    
    // Clear any transition classes
    el.classList.remove('price-updating');
    el.classList.remove('price-entering');
  });
  
  // Reset component flags if necessary
  if (quantitySelectorExists) {
    setTimeout(() => {
      if (qs._preUpdatedPrice) {
        qs._preUpdatedPrice = false;
      }
    }, 300);
  }
});

//Fallback logic: If the default button (per schema) is hidden, then the other becomes default

{

var defaultButtonSetting = ""; // "button1" or "button2"

var btn1 = document.getElementById("button-1");

var btn2 = document.getElementById("button-2");



if (defaultButtonSetting === "button1") {

  if (btn1 && btn1.style.display === "none" && btn2 && btn2.style.display !== "none") {

    btn1.classList.remove("selected");

    btn2.classList.add("selected");

    btn2.style.border = "2px solid #000";

    btn2.style.backgroundColor = "";

  }

} else if (defaultButtonSetting === "button2") {

  if (btn2 && btn2.style.display === "none" && btn1 && btn1.style.display !== "none") {

    btn2.classList.remove("selected");

    btn1.classList.add("selected");

    btn1.style.border = "2px solid #000";

    btn1.style.backgroundColor = "";

  }

}

};

// Helper function (same as CompactComboOffers uses)
function calculateDiscountedPriceForButton(variant, buttonType, config) {
  if (!variant) return { salePrice: 0, comparePrice: 0 };
  
  const basePrice = variant.price;
  const compareAtPrice = variant.compare_at_price || 0;
  
  let quantity = config.button1_quantity || 1;
  let discountPct = (config.button1_discount_off || 0) / 100;
  
  if (buttonType === "button2") {
    quantity = config.button2Quantity || 2;
    discountPct = (config.button2_discount_off || 15) / 100;
  } else if (buttonType === "button3") {
    quantity = config.button3Quantity || 3;
    discountPct = (config.button3_discount_off || 20) / 100;
  }
  
  let salePrice = basePrice * quantity;
  let comparePrice = compareAtPrice * quantity;
  
  if (discountPct > 0) {
    salePrice = salePrice * (1 - discountPct);
    if (compareAtPrice === 0) {
      comparePrice = basePrice * quantity;
    }
  } else {
    comparePrice = compareAtPrice > 0 ? compareAtPrice * quantity : 0;
  }
  
  return {
    salePrice: Math.round(salePrice),
    comparePrice: Math.round(comparePrice)
  };
}

